import { useReactiveVar } from "@apollo/client";
import React from "react";
import { isLoggedInVar } from "./apollo";

import { LoggedInRouter } from "./routers/logged-in-router";
import { LoggedOutRouter } from "./routers/logged-out-router";
import { ThemeProvider } from "./contexts/theme-context";

function App() {
  const isLoggedIn = useReactiveVar(isLoggedInVar);
  return (
    <ThemeProvider>
      {isLoggedIn ? <LoggedInRouter /> : <LoggedOutRouter />}
    </ThemeProvider>
  );
}

export default App;
